module.exports = __webpack_public_path__ + "static/media/color-analyzer6.e3f9dc93.png";